import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { dataGridStyles } from './dataGridStyles';

import { 
  DataGridPro,
  GridToolbar,
   } from '@mui/x-data-grid-pro';
import { Typography } from '@mui/material';
import { height } from '@mui/system';


export default function LocationGrid(props) {

  // console.log("LocationGrid", props.gridData)
  //if no props filter model is passed, set it to empty
  const [selectedModel, setSelectedModel ] = React.useState();
  const  GridData  = {
    columns: props.gridColumns, 
    rows: props.gridData
    };
  // Calculate the total for the "No Inbound" column
//   const totalNoInbound = React.useMemo(() => {
//     return GridData.reduce((sum, row) => sum + (row.count || 0), 0);
//   }, [GridData]);


  return (

    <Grid container
      sx={{ 
        display: 'flex',
        width: "100%",
        height: "100%",
        border: 0,
        justifyContent: 'flex-start',
        direction: 'row',
        overflow: 'hidden',

      }}>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{alignContent: 'center', justifyContent:'center', border: 0, pt:1}}>
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Typography variant="h6" gutterBottom sx={{ textAlign: 'center' }} >{props.gridTitle}</Typography>
          </Box>
        </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} sx={{alignContent: 'center', border: 0}}>
      <DataGridPro
        sx={{
            ...dataGridStyles.root,
            height: 600
        }}
        hideFooter
        // pagination // Enable pagination
        initialState={{
            scroll: { top: 10 },
        }}
        slots={{toolbar: GridToolbar}}
        getRowId={(row) => row.id}
        {...GridData} 
      
      
      />
    </Grid>
    </Grid>

  );
};